import React from 'react';
import Chart from 'react-apexcharts';
import { formatarData } from './UsinaResumoCards';

export default function UsinaCurvaPotencia({ curva, diaResumo, loading }: any) {
    const registros = curva?.registros || [];

    const series = [{
        name: 'Potência (kW)',
        data: registros.map((item: any) => ({
            x: new Date(String(item.data_hora).replace(' ', 'T')).getTime(),
            y: item.potencia,
        })),
    }];

    // O eixo cobre o dia inteiro, das 00:00 às 23:59, para a escala não mudar
    // conforme a janela de registros de cada dia
    const inicioDia = curva?.data ? new Date(`${curva.data}T00:00:00`).getTime() : undefined;
    const fimDia = curva?.data ? new Date(`${curva.data}T23:59:59`).getTime() : undefined;

    const options: any = {
        chart: {
            type: 'area',
            toolbar: { show: false },
            zoom: { enabled: false, allowMouseWheelZoom: false },
            animations: { enabled: false },
        },
        colors: ['#e2603f'],
        dataLabels: { enabled: false },
        stroke: { width: 2, curve: 'smooth' },
        fill: {
            type: 'gradient',
            gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0, stops: [0, 90, 100] },
        },
        markers: { size: 0 },
        xaxis: {
            type: 'datetime',
            min: inicioDia,
            max: fimDia,
            tickAmount: 12,
            labels: { datetimeUTC: false, format: 'HH:mm' },
        },
        yaxis: { min: 0, forceNiceScale: true },
        tooltip: { x: { format: 'dd/MM HH:mm' }, y: { formatter: (valor: number) => `${Number(valor).toFixed(2)} kW` } },
    };

    const resumoDia = diaResumo
        ? [
            diaResumo.geracao !== null ? `${diaResumo.geracao} kWh` : 'sem geração registrada',
            diaResumo.horas_sol !== null ? `${diaResumo.horas_sol} h de sol` : null,
            diaResumo.pico !== null ? `pico ${diaResumo.pico} kW` : null,
            diaResumo.clima,
        ].filter(Boolean).join(' · ')
        : '';

    return (
        <div className="usina-bloco">
            <div className="usina-bloco-header">
                <div className="usina-bloco-titulo">
                    Dia
                    <span className="usina-bloco-hint">{curva?.data ? formatarData(curva.data) : 'nenhum dia selecionado'}</span>
                </div>
                <div className="usina-bloco-controles">
                    <span className="usina-bloco-total">{resumoDia}</span>
                </div>
            </div>

            <div className="usina-chart-box is-curva">
                {loading && <div className="usina-vazio">Carregando...</div>}
                {!loading && registros.length === 0 && (
                    <div className="usina-vazio">{curva?.aviso || 'Sem dados granulares para esta data.'}</div>
                )}
                {!loading && registros.length > 0 && (
                    <Chart options={options} series={series} type="area" width="100%" height="100%" />
                )}
            </div>
        </div>
    );
}
